import React,{useState, useEffect} from 'react'
import { Route, Routes, Navigate } from 'react-router-dom';
import "./mainPage.css"
import leftBanner from "../../images/leftBanner.png"
import pictograms from "../../images/pictograms.png"
import igIcon from "../../images/igIcon.svg"
import fbIcon from "../../images/fbIcon.svg"
import Winners from '../winnersContent/winners';
import fetchWinners from '../../API/fetchWinners'

function MainPage({winners,handleWinners}) {


     useEffect(() => {
        let fetch = async () => {
            let response = await fetchWinners()

            if (response?.data?.success?.data?.winners) {
                handleWinners(response.data.success.data.winners)

            }

        }

        fetch()

    }, [1])  

    return (
        <div className="mainPage">
            <img src={leftBanner}
                className="leftBanner" />
            <img src={pictograms}
                className="pictograms" />

            <Routes>
                <Route path="/dobitnici" element={<Winners winners={winners} handleWinners={handleWinners} />} />
                <Route path="*" element={<Navigate to="/dobitnici" replace />} />
            </Routes>

            <div className="desktopIcons">
                <a href="https://www.instagram.com/zajecarsko.pivo/" target='_blank'>
                    <img src={igIcon} />
                </a>

                <a href="https://www.facebook.com/pivo.zajecarsko" target='_blank'>
                    <img src={fbIcon} />
                </a>
            </div>


        </div>
    )
}

export default MainPage

{/* */ }
